import React from 'react';
import ReactECharts from 'echarts-for-react';
import { format, parseISO } from 'date-fns';

const MaintenanceAnalytics = ({ maintenance }) => {
  const completed = maintenance.filter(m => m.status === 'Completed');
  
  // 1. Spend Over Time (Monthly)
  const monthlySpend = completed.reduce((acc, m) => {
    const month = format(parseISO(m.completedDate), 'MMM yy');
    acc[month] = (acc[month] || 0) + (m.actualCost || 0);
    return acc;
  }, {});

  const months = Object.keys(monthlySpend).sort((a,b) => new Date(a) - new Date(b));

  // 2. Category Distribution
  const categoryData = completed.reduce((acc, m) => {
    acc[m.category] = (acc[m.category] || 0) + 1;
    return acc;
  }, {});

  const pieData = Object.entries(categoryData).map(([name, value]) => ({ name, value }));

  const lineOption = {
    tooltip: { trigger: 'axis' },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
    xAxis: { type: 'category', data: months, axisLine: { show: false } },
    yAxis: { type: 'value', axisLabel: { formatter: '${value}' }, splitLine: { lineStyle: { type: 'dashed' } } },
    series: [{
      data: months.map(m => monthlySpend[m]),
      type: 'line',
      smooth: true,
      lineStyle: { width: 4, color: '#4F46E5' },
      areaStyle: { color: 'rgba(79, 70, 229, 0.1)' },
      showSymbol: false
    }]
  };

  const pieOption = {
    tooltip: { trigger: 'item' },
    legend: { bottom: 0, icon: 'circle', textStyle: { fontSize: 10, fontWeight: 'bold' } },
    series: [{
      type: 'pie',
      radius: ['40%', '70%'],
      avoidLabelOverlap: false,
      itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
      label: { show: false },
      data: pieData,
      color: ['#4F46E5', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6']
    }]
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
      <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
        <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-6">Maintenance Spend Trend</h3>
        <div className="h-[300px]">
          <ReactECharts option={lineOption} style={{ height: '100%' }} />
        </div>
      </div>
      <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
        <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-6">Issue Type Distribution</h3>
        <div className="h-[300px]">
          <ReactECharts option={pieOption} style={{ height: '100%' }} />
        </div>
      </div>
    </div>
  );
};

export default MaintenanceAnalytics;